import { Avatar, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const MainLayoutHeaderProfileUserBoxStyled = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  })
);

export const MainLayoutHeaderProfileUserDataStyled = styled(Box)(
  ({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  })
);

export const MainLayoutHeaderProfileUserNameTypographyStyled = styled(
  Typography
)({
  whiteSpace: 'nowrap',
});

export const MainLayoutHeaderProfileAvatarStyled = styled(Avatar)({
  width: '36px',
  height: '36px',
});

export const MainLayoutHeaderProfileButtonExitStyled = styled(Button)(
  ({ theme }) => ({
    flexShrink: 0,
    borderRadius: 0,
    backgroundColor: theme.palette.secondary.light,
    '& svg': {
      flexShrink: 0,
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.light,
    },
    color: theme.palette.secondary.dark,
    [theme.breakpoints.down('sm')]: {
      minWidth: '36px',
    },
  })
);

export const MainLayoutHeaderProfileButtonTextSx = {
  color: 'inherit',
  display: { xs: 'none', sm: 'inline' },
};
